import { useEffect } from 'react';

import { useSelectedEdge } from '~/api/easy-estimator-api/edges-api/hooks/useSelectedEdge';
import { IMAGE_COMING_SOON, UNIT_MEASURE } from '~/core/constants';
import { EdgeModel } from '~/core/models';
import {
  formatPriceUnitOrFree,
  getProductDescription,
  imgUrl,
} from '~/core/utils';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectUserSelectedEdge,
  updateUserSelectedEdge,
} from '~/redux/slices/edge';
import { useDrawingShapeContext } from '~contexts';
import DesignStepContainer from '~molecules/DesignStepContainer';
import DesignSectionCard from '~organisms/DesignSectionCard';

type EdgesListProps = {
  edges: EdgeModel[];
  onClick3DBtn: (index: number) => void;
  selectManualEdge: (edge: EdgeModel) => void;
};

const EdgesList = ({ edges, selectManualEdge }: EdgesListProps) => {
  const dispatch = useAppDispatch();
  const { selectedValue: selectedEdge } = useSelectedEdge();
  const userSelectedEdge = useAppSelector(selectUserSelectedEdge);

  const getEdgePrice = (edge: EdgeModel) =>
    formatPriceUnitOrFree(
      edge.price,
      edge.unitOfMeasure || UNIT_MEASURE.EDGE,
      true
    );

  const getImageUrl = (edge: EdgeModel) =>
    edge.imageUrl ? imgUrl(edge.imageUrl, 300) : IMAGE_COMING_SOON;

  const {
    getters: { areThereShapesInTheDrawingArea },
  } = useDrawingShapeContext();

  useEffect(() => {
    if (selectedEdge && !userSelectedEdge) {
      dispatch(updateUserSelectedEdge(selectedEdge));
    }
  }, [dispatch, selectedEdge, userSelectedEdge]);

  return (
    <DesignStepContainer>
      {edges.map((edge, i) => (
        <DesignSectionCard
          key={`edge-${i}`}
          title={getProductDescription(edge)}
          image={getImageUrl(edge)}
          onClick={() => selectManualEdge(edge)}
          isSelected={
            areThereShapesInTheDrawingArea &&
            selectedEdge?.productId === edge?.productId
          }
        >
          <p>{getEdgePrice(edge)}</p>
        </DesignSectionCard>
      ))}
    </DesignStepContainer>
  );
};

export default EdgesList;
